import React from "react";
import print from "../images/Print.png"

const OpdTable = () => {
  return (
    <div className="flex justify-center w-full bg-gray-100 h-screen ">
   
    <div className="px-5 py-5  bg-white w-[95%] mt-5 mb-5 rounded-2xl">

        <div className="flex justify-between ">
            <div className=" flex  items-center  gap-2">
    <div className="flex items-center gap-2">
        <div className=" text-xs rounded-lg">Show</div>
       <div>
    <select name="UHID" id="" className="border border-1 p-1 border-gray-100 text-xs rounded-lg">
        <option value="Uhid"> 10</option>
                <option value="PatientId"> 20</option>


    </select>

</div>
  <div className=" text-xs rounded-lg">Enteries</div>
    </div>


<div className="flex items-center gap-2 ">


  
<div  className="border border-1 border-gray-100 text-xs p-1  rounded-lg">icon</div>
</div>

<div>
    <select name="UHID" id="" className="border border-1 p-1 border-gray-100 text-xs rounded-lg">
        <option value="Uhid"> UHID</option>
                <option value="PatientId"> PatientId</option>


    </select>
</div>



<div><input type="text" placeholder="Search" className=" bg-gray-100 w-[300px] text-xs p-1 rounded-lg"/></div>

     </div>



     <div className=" flex text-xs items-center  gap-2">
<div className="flex flex-col">
    <div className="flex justify-center ">
            <img src={print} alt="" className=" w-3 h-3"/>
    </div> 
    <p>print</p>
</div>
<div className="flex flex-col">
     <div className="flex justify-center ">
            <img src={print} alt="" className=" w-3 h-3"/>
    </div>
    <p>Download</p>
</div>
<div className="flex flex-col">
    <div className="flex justify-center ">
            <img src={print} alt="" className=" w-3 h-3"/>
    </div>
    <p>Refresh</p>
</div><div className="flex flex-col">
    <div className="flex justify-center ">
            <img src={print} alt="" className=" w-3 h-3"/>
    </div>
    <p>Configure Grid</p>
</div><div className="flex flex-col">
 <div className="flex justify-center ">
            <img src={print} alt="" className=" w-3 h-3"/>
    </div>
    <p>Table</p>
</div>


     </div>
     </div>


<div className="bg-green-50 p-2 mt-5">
<table>

     <thead className="bg-gray-100">
          <tr className="font-semibold">
            <th className="px-2 py-1 text-xs">UHID</th>
            <th className="px-2 py-1 text-xs">Registration Mode</th>
            <th className="px-2 py-1 text-xs">Full Name</th>
            <th className="px-2 py-1 text-xs">DOR</th>
            <th className="px-2 py-1 text-xs">Gender</th>
            <th className="px-2 py-1 text-xs">Patient Type</th>
            <th className="px-2 py-1 text-xs">Age</th>
            <th className="px-2 py-1 text-xs">City</th>
            <th className="px-2 py-1 text-xs">VIP</th>
            <th className="px-2 py-1 text-xs">MLC</th>
            <th className="px-2 py-1 text-xs">Status</th>
            <th className="px-2 py-1 text-xs">Action</th>
          </tr>
        </thead>
       <tbody>
          <tr className="border-t">
            <td className="px-2 py-1 text-xs">UHID001</td>
            <td className="px-2 py-1 text-xs">Online</td>
            <td className="px-2 py-1 text-xs">John Doe</td>
            <td className="px-2 py-1 text-xs">2025-10-06</td>
            <td className="px-2 py-1 text-xs">Male</td>
            <td className="px-2 py-1 text-xs">Outpatient</td>
            <td className="px-2 py-1 text-xs">32</td>
            <td className="px-2 py-1 text-xs">New York</td>
            <td className="px-2 py-1 text-xs">No</td>
            <td className="px-2 py-1 text-xs">No</td>
            <td className="px-2 py-1 text-green-600 text-xs">Active</td>
            <td className="px-2 py-1">
              <button className="text-xs">Edit</button>
            </td>
          </tr>
          <tr className="border-t">
            <td className="px-2 py-1">UHID002</td>
            <td className="px-2 py-1">Offline</td>
            <td className="px-2 py-1">Jane Smith</td>
            <td className="px-2 py-1">2025-10-05</td>
            <td className="px-2 py-1">Female</td>
            <td className="px-2 py-1">Inpatient</td>
            <td className="px-2 py-1">45</td>
            <td className="px-2 py-1">Los Angeles</td>
            <td className="px-2 py-1">Yes</td>
            <td className="px-2 py-1">Yes</td>
            <td className="px-2 py-1 text-red-600">Inactive</td>
            <td className="px-2 py-1">
              <button className="text-blue-500 hover:underline">Edit</button>
            </td>
          </tr>
        </tbody>
  




</table>


</div>
    </div>
    </div>
  );
};

export default OpdTable;
